if (window.location.hostname.includes('aroma360.com')) {

  function cleanupUnwantedElements() {
    let removedCount = 0;
    const repLoaderId = document.getElementById('repLoader');
    if (repLoaderId) {
      repLoaderId.remove();
      removedCount++;
      console.log('✅ Removed #repLoader (by ID)');
    }
    document.querySelectorAll('script[src*="repLoader"]').forEach(script => {
      script.remove();
      removedCount++;
      console.log('✅ Removed repLoader script by src');
    });
    document.querySelectorAll('script').forEach(script => {
      if (script.textContent && script.textContent.includes('repLoader')) {
        script.remove();
        removedCount++;
        console.log('✅ Removed inline repLoader script');
      }
    });
    const vfChat = document.getElementById('vfChat');
    if (vfChat) {
      vfChat.remove();
      removedCount++;
      console.log('✅ Removed #vfChat');
    }
    const repWebClient = document.getElementById('repWebClientContainer');
    if (repWebClient) {
      repWebClient.remove();
      removedCount++;
      console.log('✅ Removed #repWebClientContainer');
    }
    if (removedCount > 0) {
      console.log(`🎉 Cleanup complete — Removed ${removedCount} unwanted element(s)!`);
    }
  }
  cleanupUnwantedElements();

  const observer = new MutationObserver(cleanupUnwantedElements);

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  setTimeout(() => {
    observer.disconnect();
  }, 45000);
                   
} else {
  console.log('⏭️ skipping cleanup');
}